<template>
  <div class="main-layout">
    <mobile-top-bar />
    <main class="main-layout__content">
      <router-view />
    </main>
    <bottom-navigation />
  </div>
</template>

<script>
import BottomNavigation from "../BottomNavigation.vue";
import MobileTopBar from "../MobileTopBar.vue";

export default {
  name: "MainLayout",
  components: {
    BottomNavigation,
    MobileTopBar,
  },
  mounted() {
    document.body.classList.add("has-bottom-nav", "has-mobile-topbar");
  },
  beforeDestroy() {
    document.body.classList.remove("has-bottom-nav", "has-mobile-topbar");
  },
};
</script>

<style scoped>
.main-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8fafc;
}

.main-layout__content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding-top: calc(60px + env(safe-area-inset-top, 0px));
  padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px));
}

/* Desktop adjustments */
@media (min-width: 768px) {
  .main-layout__content {
    padding-top: calc(70px + env(safe-area-inset-top, 0px));
    padding-bottom: 0;
  }
}
</style>
